import Vue from 'vue'
import Vuex from 'vuex'
import API from './API'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    developer: localStorage['devMode'] || false,
    paths: { }
  },
  mutations: {
    UpdateNode(state, payload) {
      let { path } = payload
      let existingNode = store.state.paths[path]
      let resultNode = {
        ...existingNode,
        ...payload
      }

      Vue.set(store.state.paths, path, resultNode)
    }
  },
  actions: {
    GetPath({ commit }, path) {
      let existingNode = store.state.paths[path]
      if (existingNode && existingNode.__fetched) return

      API.WZ(path).then(results => {
        let children = results.children
        delete results.children
        results.path = path
        results.__fetched = true

        console.log('Fetch', path)

        commit('UpdateNode', results)

        children.forEach(childName => {
          let childNode = {
            path: `${path}/${childName}`,
            name: childName
          }
          commit('UpdateNode', childNode)
        })
      })
    }
  }
})

export default store